import {Component} from "vue-property-decorator";
import {Flow, FlowEditorResult, NextCondition, Node} from "@/app/interfaces";
import {VueWizard} from "@/vue-wizard";
import {NodeTypes} from "@/app/enums";
import {store} from "@/app/store";
const _ = require('lodash');

@Component({name: "flow-editor"})
export default class FlowEditor extends VueWizard {

    get flows(): Flow[] {
        return _.cloneDeep(store.state.flows);
    }

    get originalFlows(): Flow[]{
        return _.cloneDeep(store.state.originalFlows);
    }

    get initialFlowId(): string {
        return _.cloneDeep(store.state.initialFlowId ? store.state.initialFlowId : '');
    }

    private selectedItem: FlowEditorResult | null;

    public nodeTypes: typeof NodeTypes;
    public emittedOptionIndex: boolean;
    public emittedOptionTimeout: number | null;
    public restablishButtonMainClassName = 'restablish-button';


    constructor() {
        super();
        this.nodeTypes = NodeTypes;
        this.emittedOptionIndex = false;
        this.emittedOptionTimeout = null;
        this.selectedItem = null;
    }

    getFlowByName(node: Node, index: number, option: boolean): Flow | undefined {
        let name: string | undefined;
        if(option) {
            name = node.next
                ? (node.next[index] as NextCondition).true.replace('@FLOW:', '')
                : undefined
        } else {
            name = node.next
                ? (
                    (node.next[index] as NextCondition).false
                    ? (node.next[index] as NextCondition).false!.replace('@FLOW:', '')
                    : undefined
                )
                : undefined
        }
        if(name) {
            return this.flows.find(flow => flow.name === name)
        } else {
            return undefined
        }
    }

    onSelected($event: MouseEvent, flowId: string, nodeIndex: number, optionIndex?: any) {
        if(!($event.target as any).classList.contains(this.restablishButtonMainClassName)){
            if(!this.selectedItem || this.selectedItem.text.trim().length > 0) {
                let text: string;
                if (optionIndex !== undefined) {
                    text = this.flows[this.findFlowById(flowId, this.flows)].nodeList[nodeIndex].options![optionIndex].label
                } else {
                    text = this.flows[this.findFlowById(flowId, this.flows)].nodeList[nodeIndex].text![0]
                }
                if(optionIndex !== undefined) {
                    if(this.emittedOptionTimeout) {
                        clearTimeout(this.emittedOptionTimeout)
                    }
                    this.emittedOptionIndex = true;
                    this.emittedOptionTimeout = setTimeout(() => this.emittedOptionIndex = false, 1);
                    this.selectedItem = {text, nodeIndex, flowId, optionIndex}
                }
                if(!this.emittedOptionIndex) {
                    this.selectedItem = {text, nodeIndex, flowId}
                }
            }
        }
    }

    onSave() {
        setTimeout(() => this.selectedItem = null, 100)
    }

    onchange(flowId: string, nodeIndex: number, optionIndex?: any) {
        if(this.selectedItem!.text.trim().length > 0) {
            const flows = this.flows;
            if(optionIndex !== undefined) {
                flows[this.findFlowById(flowId, flows)].nodeList[nodeIndex].options![optionIndex].label = this.selectedItem!.text;
            } else {
                flows[this.findFlowById(flowId, flows)].nodeList[nodeIndex].text![0] = this.selectedItem!.text
            }
            store.commit('setFlows', flows)
        }
    }

    restablishNode(flowId: string, nodeIndex: number, optionIndex?: any){
        const flows = this.flows;
        const originalFlows =  this.originalFlows;

        if(optionIndex !== undefined) {
            const originalFlowText = originalFlows[this.findFlowById(flowId, originalFlows)].nodeList[nodeIndex].options![optionIndex].label;
            flows[this.findFlowById(flowId, flows)].nodeList[nodeIndex].options![optionIndex].label = originalFlowText;
        } else {
            const originalFlowText = originalFlows[this.findFlowById(flowId, originalFlows)].nodeList[nodeIndex].text![0]
            flows[this.findFlowById(flowId, flows)].nodeList[nodeIndex].text![0] = originalFlowText;
        }

        store.commit('setFlows', flows)
    }

    evaluateSelectedItem(flowId: string, nodeIndex: number, optionIndex?: any): boolean {
        let result = false;
        if(this.selectedItem) {
            if(optionIndex !== undefined) {
                result = this.selectedItem.optionIndex !== undefined && this.selectedItem.optionIndex === optionIndex
            } else {
                result = this.selectedItem.optionIndex === undefined
            }
            return result && this.selectedItem.flowId === flowId && this.selectedItem.nodeIndex === nodeIndex
        }
        return result
    }

    findFlowById(id: string, array: Flow[]): number {
        return array.findIndex(flow => flow._id === id)!
    }

    getFlowName(name: string) {
        return this.getNodeName(name.replace("@FLOW:", ""))
    }

    getNodeName(name: string) {
        return name.split("_").join(' ')
    }

}